import { all } from 'redux-saga/effects';
import Auth from './Auth';
import Language from './Language';
import AiTranslation from './AiTranslation';

export default function* rootSaga(getState) {
  yield all([Auth(), Language(), AiTranslation()]);
}
